// extracted by mini-css-extract-plugin
module.exports = {"button-rounded":"styles__button-rounded__1X5xQ","buttonRounded":"styles__button-rounded__1X5xQ"};